var _ellipse, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 55,
    viewBox: "0 0 57 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.1707,
    cy: 27.5,
    rx: 28.1707,
    ry: 27.5,
    fill: "#F1F2F3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_300_4382",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1709,
    y: 12.9999,
    width: 29.0977,
    height: 29.0977,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_300_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3206 26.6394H29.1182V17.9662C29.1182 17.576 28.9826 17.2453 28.7114 16.9741C28.4402 16.7027 28.1096 16.567 27.7194 16.567C27.3292 16.567 26.9985 16.7027 26.7273 16.9741C26.4561 17.2453 26.3206 17.576 26.3206 17.9662V26.6394ZM19.1625 31.2559H36.2762V28.8311C36.2762 28.7222 36.2412 28.6328 36.1713 28.5629C36.1012 28.4929 36.0118 28.458 35.9031 28.458H19.5357C19.4269 28.458 19.3375 28.4929 19.2674 28.5629C19.1975 28.6328 19.1625 28.7222 19.1625 28.8311V31.2559ZM17.801 38.5303H20.8647V35.8024C20.8647 35.5444 20.9517 35.3283 21.1257 35.1541C21.2999 34.9801 21.516 34.8931 21.7741 34.8931C22.0321 34.8931 22.2481 34.9801 22.4221 35.1541C22.5963 35.3283 22.6834 35.5444 22.6834 35.8024V38.5303H26.8101V35.8024C26.8101 35.5444 26.8972 35.3283 27.0713 35.1541C27.2453 34.9801 27.4613 34.8931 27.7194 34.8931C27.9774 34.8931 28.1934 34.9801 28.3674 35.1541C28.5416 35.3283 28.6287 35.5444 28.6287 35.8024V38.5303H32.7554V35.8024C32.7554 35.5444 32.8425 35.3283 33.0167 35.1541C33.1906 34.9801 33.4066 34.8931 33.6647 34.8931C33.9227 34.8931 34.1388 34.9801 34.313 35.1541C34.487 35.3283 34.574 35.5444 34.574 35.8024V38.5303H37.6377C37.762 38.5303 37.863 38.4817 37.9408 38.3845C38.0186 38.2873 38.038 38.1804 37.999 38.0638L36.6469 33.0745H18.7918L17.4397 38.0638C17.4007 38.1804 17.4201 38.2873 17.4979 38.3845C17.5757 38.4817 17.6767 38.5303 17.801 38.5303ZM37.7311 40.3489H17.7077C17.0206 40.3489 16.4619 40.0745 16.0315 39.5257C15.6009 38.9771 15.4789 38.3654 15.6654 37.6907L17.3439 31.4541V28.7611C17.3439 28.1721 17.5503 27.6711 17.9632 27.2583C18.3758 26.8457 18.8766 26.6394 19.4656 26.6394H24.502V17.9662C24.502 17.0724 24.8148 16.3126 25.4404 15.6868C26.066 15.0612 26.8256 14.7484 27.7194 14.7484C28.6131 14.7484 29.3728 15.0612 29.9984 15.6868C30.624 16.3126 30.9368 17.0724 30.9368 17.9662V26.6394H35.9731C36.5621 26.6394 37.063 26.8457 37.4756 27.2583C37.8884 27.6711 38.0948 28.1721 38.0948 28.7611V31.4541L39.7734 37.7141C39.9973 38.3809 39.8908 38.9868 39.4539 39.5318C39.0172 40.0765 38.443 40.3489 37.7311 40.3489Z",
    fill: "#3D4259"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearDash);
export default __webpack_public_path__ + "static/media/clear_dash.ea514df2f7f6165e4cce3260abcd058d.svg";
export { ForwardRef as ReactComponent };